module.exports = __webpack_public_path__ + "img/forge-app-placeholder.b85f1f01.svg";